import React from "react";
import styles from "./TopicColors.module.sass";
import cn from "classnames";
import Card from "../../../../../components/Card";


const TopicColors = ({
                       className,
                       textColor,
                       setTextColor,
                       backgroundColor,
                       setBackgroundColor
                     }) => {

  return (
      <Card className={cn(styles.card, className)} >
        <div className={styles.list}>
          <div className={styles.item}>
            <div className={styles.colorSection}>

              {/* Text Color */}
              <div className={styles.colorField}>
                <div className={styles.category}>Text color</div>

                <div className={styles.colorInputWrapper}>
                  <input
                      type="text"
                      className={styles.colorInput}
                      value={textColor}
                      onChange={(e) => setTextColor(e.target.value)}
                      placeholder="#FFF9097"
                  />
                  <input
                      type="color"
                      value={textColor}
                      onChange={(e) => setTextColor(e.target.value)}
                      className={styles.colorPreview}
                      title="Select text color"
                  />
                </div>
              </div>

              {/* Background Color */}
              <div className={styles.colorField}>
                <div className={styles.category}>Background color</div>

                <div className={styles.colorInputWrapper}>
                  <input
                      type="text"
                      className={styles.colorInput}
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      placeholder="#FFF9097"
                  />
                  <input
                      type="color"
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      className={styles.colorPreview}
                      title="Select background color"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
  );
};

export default TopicColors;